module.exports = __webpack_public_path__ + "img/fwx6.0a140e5e.png";